/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Intensity_Factor_RangeInputs */

const en_exp_intensity_factor_range = /** @type {(inputs: Exp_Intensity_Factor_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below 0.75: easy endurance. 0.75–0.85: tempo. 0.85–0.95: sweet spot. Around 1.0: a full-gas hour.`)
};

const de_exp_intensity_factor_range = /** @type {(inputs: Exp_Intensity_Factor_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 0,75: lockere Ausdauer. 0,75–0,85: Tempo. 0,85–0,95: Sweet Spot. Um 1,0: eine Stunde Vollgas.`)
};

/**
* | output |
* | --- |
* | "Below 0.75: easy endurance. 0.75–0.85: tempo. 0.85–0.95: sweet spot. Around 1.0: a full-gas hour." |
*
* @param {Exp_Intensity_Factor_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_intensity_factor_range = /** @type {((inputs?: Exp_Intensity_Factor_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Intensity_Factor_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_intensity_factor_range(inputs)
	return de_exp_intensity_factor_range(inputs)
});